import {browseLink} from './constValues';
import {isPropertyShortPath} from '../../../helpers/common';

function normalizePathname(pathname) {
  if (!pathname) {
    return '';
  }
  return pathname.startsWith('/') ? pathname : `/${pathname}`;
}

function pathnameToBrowseHref(pathname) {
  const normalized = normalizePathname(pathname);
  const parts = normalized
    .replace(/\/$/, '')
    .split('/')
    .filter(Boolean);

  if (parts.length >= 2 && parts[0] !== 'browse' && parts[1].toLowerCase() === 'us') {
    const tail = parts.slice(1);
    if (tail.length === 1) {
      return browseLink;
    }
    return `/browse/${tail.join('/')}`.toLowerCase();
  }

  return null;
}

function getStoredMapMarketPath() {
  if (typeof window === 'undefined') {
    return '';
  }
  const stored = localStorage.getItem('city-search') || '';
  if (!stored || isPropertyShortPath(stored)) {
    return '';
  }
  return pathnameToBrowseHref(stored) ? stored : '';
}

/**
 * Map URL → browse directory URL for the same geographic context (pathname only).
 * On /zoning-detail/… uses marketPath (Redux place) or city-search when the URL has no /us/ segment.
 */
export default function buildBrowseHrefFromLocation(location, marketPath = '') {
  const pathname = location?.pathname || '';

  if (!isPropertyShortPath(pathname)) {
    const fromPath = pathnameToBrowseHref(pathname);
    if (fromPath) {
      return fromPath;
    }
  }

  const candidates = [normalizePathname(marketPath), getStoredMapMarketPath()].filter(Boolean);
  for (let i = 0; i < candidates.length; i += 1) {
    const fromFallback = pathnameToBrowseHref(candidates[i]);
    if (fromFallback) {
      return fromFallback;
    }
  }

  return browseLink;
}
